import { Output, EventEmitter, ChangeDetectionStrategy, Input, Component, ChangeDetectorRef} from '@angular/core';
import {SelectItem} from 'primeng/api';
import {UntypedFormGroup, UntypedFormBuilder, Validators, ValidatorFn, ValidationErrors} from '@angular/forms';
import {MftPreviewDialogResult} from '@feature/preview-mode/mft-preview-mode/models/mft-preview-dialog-result';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'mojo-mft-preview-mode-dialog',
  templateUrl: './mft-preview-mode-dialog.component.html'
})
export class MftPreviewModeDialogComponent {

  @Input()
  title = 'Preview';

  @Input()
  users: SelectItem[];

  @Input()
  tenants: SelectItem[];

  @Input()
  tenantParents: SelectItem[];

  @Input()
  showDialog: boolean;

  @Output()
  onOk = new EventEmitter<MftPreviewDialogResult>();

  @Output()
  onCancel = new EventEmitter();

  previewByOptions: SelectItem[];
  form: UntypedFormGroup;

  constructor(
    formBuilder: UntypedFormBuilder,
    private readonly cd: ChangeDetectorRef) {
    this.form = this.createForm(formBuilder);
    this.previewByOptions = this.getPreviewByOptions();
  }

  cancelHandler() {
    this.showDialog = false;
    this.onCancel.emit();
  }

  okHandler() {
    const result = this.mapToResult();
    this.showDialog = false;
    this.onOk.emit(result);
  }

  private mapToResult() {
    const result = new MftPreviewDialogResult();
    result.previewBy = this.form.get('previewBy').value;
    result.tenant = this.form.get('selectedTenant').value;
    result.previewAsUserId = this.form.get('selectedUser').value;
    result.tenantParent = this.form.get('selectedTenantParent').value;
    return result;
  }

  get previewByValue() {
    return this.previewBy.value;
  }

  get previewBy() {
    return this.form.get('previewBy');
  }

  private formValidator(): ValidatorFn {
    return (control: UntypedFormGroup): ValidationErrors | null => {

      const errors: ValidationErrors = {};
      const pBy = control.get('previewBy').value;
      if (pBy === 'tenant' && !control.get('selectedTenant').value) {
          errors.tenantRequired = { message: 'Tenant required' };
      }

      if (pBy === 'tenantParent' && !control.get('selectedTenantParent').value) {
        errors.tenantParentRequired = { message: 'Tenant Parent required' };
      }

      if (pBy === 'user' && !control.get('selectedUser').value) {
        errors.userRequired = { message: 'User required' };
      }

      return Object.keys(errors).length ? errors : null;

    };

  }

  private createForm(formBuilder: UntypedFormBuilder) {
    const form = formBuilder.group({
      previewBy: [null, [Validators.required]],
      selectedTenant: [null],
      selectedTenantParent: [null],
      selectedUser: [null],
    },
    {
      validator: this.formValidator()
    }
    );
    return form;
  }

  private getPreviewByOptions() {
    const l = [
      { label: 'Tenant', value: 'tenant' },
      { label: 'Tenant Parent', value: 'tenantParent' },
      { label: 'User', value: 'user' },
    ];
    return l;
  }

}
